import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { UrlSearch } from '@/util/index'
import UpgradeBox from '@/components/common/UpgradeBox.vue'
import versions from '@/config/clientVersion'
import { record } from '@/util/dataReport.js'
import { Message } from 'element-ui'

const languageMap = {
  'en': 1,
  'zh-CN': 2,
  'ru-RU': 3,
  'fr-FR': 4,
  'de': 5,
  'pt-PT': 6,
  'es': 7
}

// 当前升级时间
let upgradeTime = 0

// 创建一个新的axios实例
const service = axios.create()

// 业务报错埋点记录
const errorRecord = (errData) => {
  record({
    eventType: 'error',
    eventId: `${router.app && router.app._route && router.app._route.meta.pageId}_error`,
    value: JSON.stringify({
      code: errData.code,
      message: errData.message
    })
  })
}

// 请求拦截器 => 处理token统一注入
service.interceptors.request.use(
  (config) => {
    config.headers['Language-Id'] = languageMap[store.state.language] || 1
    if (store.state.ticket) config.headers.Ticket = store.state.ticket
    if (store.state.common.token) config.headers.Authorization = `Bearer ${store.state.common.token}`

    // 插入版本号，有新迭代提示用户更新界面
    try {
      if (versions) {
        config.headers['Client-Version'] = versions
      }
    } catch (ex) {
      console.error('fail', ex)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200 && (response.data && response.data.code !== 10000)) {
      // errorRecord(response.data)
    }
    if (response.data && +response.data.code === 10000 || response.status === 200) {
      return response.data
    } else {
      return Promise.reject(response)
    }
  },
  (error) => {
    if (error.response.status === 500) {
      // errorRecord(error.response.data)
    }
    if (error.response.status === 429) {
      Message({
        message: 'Requests are too frequent, Please try again later.',
        type: 'error'
      })
    }
    if (error.response.status === 401) {
      if (router && router.app && router.app._route) {
        localStorage.setItem('loginRedirection', JSON.stringify({
          path: router.app._route.path,
          query: router.app._route.query
        }))
      } else {
        localStorage.setItem('loginRedirection', JSON.stringify({
          path: location.pathname,
          query: UrlSearch()
        }))
      }
      store.dispatch('logOut')
    } else if (error.response.status === 426) {
      if (new Date().getTime() - 60000 > upgradeTime) {
        upgradeTime = new Date().getTime()
        const comp = new (Vue.extend(UpgradeBox))().$mount()
        document.body.appendChild(comp.$el)
      }
    }
    return Promise.reject(error.response)
  }
)

// 导出axios实例
export default service
